"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Label_1 = require("./../Label");
var Style = require("./Heading.css");
var Heading = /** @class */ (function (_super) {
    __extends(Heading, _super);
    function Heading(props) {
        var _this = _super.call(this, props) || this;
        _this.buildClassName = function (className) {
            return className ? [
                _this.style.heading, className
            ].join(" ")
                : _this.style.heading;
        };
        var options = props.options;
        _this.style = options.style || Style;
        _this.state = {
            accessibility: options.accessibility,
            className: _this.buildClassName(options.className),
            isDecodingRequired: options.isDecodingRequired,
            prefix: options.prefix,
            size: options.size,
            text: props.data.text,
            type: options.type,
        };
        return _this;
    }
    Heading.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var newOptions = nextProps.options;
        var oldOptions = this.props.options;
        if (oldOptions.accessibility !== newOptions.accessibility) {
            this.setState({ accessibility: newOptions.accessibility });
        }
        if (oldOptions.className !== newOptions.className) {
            this.setState({
                className: this.buildClassName(newOptions.className),
            });
        }
        if (oldOptions.isDecodingRequired !== newOptions.isDecodingRequired) {
            this.setState({ isDecodingRequired: newOptions.isDecodingRequired });
        }
        if (oldOptions.prefix !== newOptions.prefix) {
            this.setState({ prefix: newOptions.prefix });
        }
        if (oldOptions.size !== newOptions.size) {
            this.setState({ size: newOptions.size });
        }
        if (this.props.data.text !== nextProps.data.text) {
            this.setState({ text: nextProps.data.text });
        }
        if (oldOptions.type !== newOptions.type) {
            this.setState({ type: newOptions.type });
        }
    };
    Heading.prototype.render = function () {
        var options = this.props.options;
        var state = this.state;
        var labelOptionals = {
            onClick: options.onClick ? options.onClick : undefined,
            role: options.role ? options.role : undefined,
            tabIndex: typeof options.tabIndex !== 'undefined' ? options.tabIndex : undefined,
        };
        return (React.createElement(state.type, __assign({ className: state.className, "data-test-id": this.props.testId }, labelOptionals),
            React.createElement(Label_1.default, { data: {
                    isDecodingRequired: state.isDecodingRequired,
                    text: state.text,
                }, options: {
                    accessibility: state.accessibility,
                    className: this.style.content,
                    prefix: state.prefix,
                    size: state.size,
                }, testId: this.props.testId + "Content" })));
    };
    return Heading;
}(React.PureComponent));
exports.default = Heading;
//# sourceMappingURL=Heading.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Heading/Heading.js
// module id = 1150
// module chunks = 8